/* eslint-disable no-console */

import { track as externalTracker } from '@pedidosya/web-native-bridges/tracker';

export const NOT_SET = '(not set)';

export function track(event, data) {
  return new Promise((resolve, reject) => {
    try {
      if (process.env.NODE_ENV === 'development') {
        console.log('[TRACK_EVENT]: ', event, data);
      } else {
        externalTracker(event, data, 'GenericLandingWebview');
      }
      resolve(event);
    } catch (e) {
      reject(e);
    }
  });
}
